module.exports = __webpack_public_path__ + "img/aw.0ba3327b.jpg";